<template>
  <!-- // position absolut pois estava ocupando um espaço deixando o layout desconfigurado -->
  <!-- v-if para abrir so quando é chamado pois estava vindo duplicado já que tem o documento na consulta e no gerenciamento -->
  <span style="position:absolute;" v-if="openDocumentItems || dialogDocument || dialogSaveOnTask">
    <!-- usado o v-show pois com o v-model ele estava fechando sozinho -->
    <!-- // Lista de documentos -->
    <v-dialog v-model="openDocumentItems" width="600" persistent>
      <template v-slot:activator="{ on }">
      </template>
      <v-card>
        <v-card-title primary-title style="padding-top: 0px;padding-bottom: 0px;height: 60px;">
          <span class="headline">{{this.$vuetify.breakpoint.smAndDown ? 'Documentos' : 'Selecione um documento'}}</span>
          <v-spacer></v-spacer>
            <v-btn icon fab @click="closeList()">
              <v-icon color="black">close</v-icon>
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="loading" style="min-height:200px;">
          <v-layout align-center justify-center style="min-height:200px;">
            <img :src="`${basePath}images/loader.gif`" width="100px" />
          </v-layout>
        </v-card-text>
        <v-list v-else style="min-height:200px;">
          <v-list-tile v-if="items.length == 0">
            <v-list-tile-title>A tarefa modelo não possui documentos personalizados</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-else-if="$vuetify.breakpoint.smAndDown">
            <v-list-tile-title>Não é possível gerar documentos pelo celular!</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-else
            v-for="(item, index) in items"
            :key="index"
            @click="openDocumentPreview(item['id'])">
            <v-list-tile-title>{{ item.id_text }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-dialog>
    <!-- Dialog para mostrar que o documento foi salvo -->
    <v-dialog v-model="dialogSaveOnTask" @keydown.esc="dialogSaveOnTask = false" persistent max-width="350" scrollable v-resize="onResizePreview">
      <v-card>
        <v-card-title style="padding: 0px; height: 30px;">
          <v-spacer></v-spacer>
          <v-btn icon fab @click="dialogSaveOnTask = false" style="padding-bottom: 0px; padding-top: 5px; height: 35px; width: 35px;">
            <v-icon color="black">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <p class="text-md-center"><span style="font-size: 16 !important; font-weight: bold;">Documento salvo na tarefa com sucesso!</span></p>
          <p class="text-md-center" style="padding-bottom: 0px">Acesse o link abaixo para visualizar</p>
          <p class="text-md-center" style="padding-bottom: 0px"><a target="_blank" :href="link">{{this.link}}</a></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="save_on_task_close" class="mx-0" flat @click.native="dialogSaveOnTask = false">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDocument" max-width="1000px" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
      <v-card height="90vh">
        <v-card-title primary-title style="padding-top: 0px;padding-bottom: 0px;height: 65px;">
          <v-layout wrap justify-space-between align-center>
            <v-flex grow>
              <span class="headline">{{this.editMode ? 'Modo de Edição' : 'Pre-visualização'}}</span>
            </v-flex>
            <v-flex grow>
              <v-btn v-if="$vuetify.breakpoint.smAndDown" outline fab @click="editMode ? clickPreviewMode() : clickEditMode()">
                <v-icon color="black">{{this.editMode ? 'visibility' : 'edit'}}</v-icon>
              </v-btn>
              <v-btn v-else outline @click="editMode ? clickPreviewMode() : clickEditMode()">
                <v-icon color="black">{{this.editMode ? 'visibility' : 'edit'}}</v-icon>{{this.editMode ? 'Pre-visualização' : 'Modo de Edição'}}
              </v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn icon fab @click="close()">
                <v-icon color="black">close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding: 0px;height:100%">
          <v-layout wrap justify-center align-center style="height:100%">
            <div v-show="editMode" style="height:100%">
              <!-- // Coloca o tipo de base64 na imagem pois ela naõ estava aparecendo no pdf quando era blob -->
              <p-text-editor ref="textEditorPreview" :imageSettingsModel="{saveFormat: 'Base64'}" @change="(val) => {this.document_text = val}" :width="$vuetify.breakpoint.smAndDown ? null : '805.70px'"  :height="'100%'"></p-text-editor>
            </div>
            <vue-document-editor v-show="!editMode" :content="[document_text]" @update:content="(val) => document_text = val[0]"
              :display="display"
              :zoom="zoom"
              :page_format_mm="page_format_mm"
              :page_margins="page_margins"
            />
            <!-- :overlay="overlay" -->
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!editMode" outline color="primary darken-2" @click="printDocument()"><v-icon>print</v-icon>{{this.$vuetify.breakpoint.smAndDown ? '' : 'IMPRIMIR'}}</v-btn>
          <v-btn v-if="!editMode" outline color="primary darken-2" @click="pdfDocument()"><v-icon>picture_as_pdf</v-icon>{{this.$vuetify.breakpoint.smAndDown ? '' : 'GERAR PDF'}}</v-btn>
          <v-btn v-if="!editMode" outline color="primary darken-2" @click="saveOnTask()"><v-icon>upload_file</v-icon>{{this.$vuetify.breakpoint.smAndDown ? '' : 'SALVAR NA TAREFA'}}</v-btn>
          <v-btn class="mx-0" @click.native="close()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  /* eslint-disable no-undef */
  import PTextEditor from './../shared/PTextEditor'
  import imageCompress from '../../mixin/imageCompress'
  import html2pdf from 'html2pdf.js'
  export default {
    components: { PTextEditor, VueDocumentEditor },
    mixins: [imageCompress],
    data: () => ({
      items: [],
      loading: false,
      basePath: process.env.API,
      openDocumentItems: false,
      dialogDocument: false,
      editMode: false,
      file: null,
      link: '',
      dialogSaveOnTask: false,
      zoom: 1.0,
      page_format_mm: [210, 297],
      page_margins: '25mm 30mm 25mm 30mm',
      display: 'grid',
      document_title: '',
      document_text: '',
      taskId: null,
      taskTemplateId: null
    }),
    methods: {
      openDocumentPreviewList (taskId, taskTemplateId) {
        this.taskId = taskId
        this.taskTemplateId = taskTemplateId
        this.loading = true
        this.openDocumentItems = true
        // Busca a lista de documentos personalizados da tarefa modelo da tarefa selecionada
        this.$http.get(`api/tasktemplate_document?where=tasktemplate_id=${this.taskTemplateId}&select=id,id_text`).then((res) => {
          this.loading = false
          this.items = res.body
        }, err => {
          console.log(err)
          this.loading = false
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar a visualização do documento, reporte o erro.', color: 'error', dialog: true})
        })
      },
      closeList () {
        this.openDocumentItems = false
        this.items = []
      },
      // overlay (page, total) {
      //   // Add page numbers on each page
      //   let html = '<div style='position: absolute; bottom: 8mm; right: 10mm'>Página ' + page + ' de ' + total + '</div>';
      //   return html;
      // },
      onResizePreview () {
        // faz calculo para saber o tamanho do documento para ficar ajustado em telas menores como no mobile
        let widthWindow = window.innerWidth || document.body.clientWidth
        if (widthWindow >= 850) {
          this.zoom = 1.00
        } else {
          this.zoom = widthWindow / 870
        }
      },
      openDocumentPreview (documentId) {
        this.editMode = false
        // Busca os campos personalizados da tarefa modelo
        this.$store.commit('loader/change_dialog', true)
        this.$http.get(`api/mount_document/${this.taskId}/${documentId}`).then((res) => {
          setTimeout(() => {
            this.document_text = res.body['description']
            this.document_title = res.body['id_text']
            // Ja deixa no tamanho correto
            this.$refs.textEditorPreview.refresh()
            let randowId = this.$refs.textEditorPreview.getRandowId()
            // insere margem no campo de documento para ficar com as msm margens do componente de documento
            document.getElementById('rteObj' + randowId + '_rte-edit-view').style.padding = this.page_margins
          }, 500)
          this.dialogDocument = true
          this.$store.commit('loader/change_dialog', false)
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar a visualização do documento, reporte o erro.', color: 'error', dialog: true})
        })
      },
      printDocument () {
        print()
      },
      clickEditMode () {
        this.editMode = true
        // expande as opções do componente de texto
        this.$refs.textEditorPreview.textToolExp = true
        this.$refs.textEditorPreview.setValue(this.document_text)
        // Ja deixa no tamanho correto
        this.$refs.textEditorPreview.refresh()
      },
      clickPreviewMode () {
        this.editMode = false
      },
      close () {
        if (this.$refs.textEditorPreview) this.$refs.textEditorPreview.setValue('')
        this.document_text = ''
        this.dialogDocument = false
      },
      getContent () {
        // Pega o html do conteudo com as paginas
        var elementHTML = document.getElementsByClassName('editor')[0].cloneNode(true)
        // let overlays = elementHTML.getElementsByClassName('overlays')[0].getElementsByClassName('overlay')
        let content = elementHTML.getElementsByClassName('content')[0]
        let pages = content.getElementsByClassName('page')
        // let indexOverlay = 0
        // overlays.forEach(overlay => {
        //   overlay.style.height = '297mm'
        //   overlay.style.top = (indexOverlay * 297) + 'mm'
        //   overlay.style.left = 0
        //   indexOverlay++
        // })
        let indexPage = 0
        for (let page of pages) {
          page.style.height = '297mm'
          page.style.top = (indexPage * 297) + 'mm'
          page.style.left = 0
          indexPage++
        }
        // tira 5 para garantir que não vai vir pagina extra
        content.style.height = ((indexPage * 297) - 5) + 'mm'
        content.style.width = '210mm'
        return content
      },
      pdfDocument () {
        this.$store.commit('loader/change_dialog', true)
        let filename = this.document_title.replace(' ', '_').replace('/', '').replace('\\', '') + '.pdf'
        // Pega o html do conteudo com as paginas
        let content = this.getContent()
        var opt = {
          margin: 0,
          filename: filename,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 1 },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        }
        html2pdf().set(opt).from(content).save().then(() => {
          this.$store.commit('loader/change_dialog', false)
        }).error(() => {
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', { text: 'Não foi possível gerar o arquivo, reporte o erro.', color: 'error', dialog: true })
        })
      },
      saveOnTask () {
        this.$store.commit('loader/change_dialog', true)
        let filename = this.document_title.replace(' ', '_').replace('/', '').replace('\\', '') + '.pdf'
        // Pega o html do conteudo com as paginas
        let content = this.getContent()
        var opt = {
          margin: 0,
          filename: filename,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 1 },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        }
        html2pdf().set(opt).from(content).outputPdf('blob').then((fileBlob, b, c) => {
          var file = new File([fileBlob], opt['filename'], { type: 'application/octet-stream' })
          let formData = new FormData()
          formData.append('file', file)
          formData.append('task_id', this.taskId)
          formData.append('user_id', this.$auth.user().id)
          formData.append('company_id', this.$auth.user().company_id)
          formData.append('connection_company_id', this.$auth.user().company_id)
          this.$http.post('api/files', formData).then((res) => {
            this.$store.commit('loader/change_dialog', false)
            this.link = `https://${window.location.hostname}/#/task_shared/${this.taskId}`
            this.dialogSaveOnTask = true
            this.$store.commit('snackbar/change_values', { text: 'Arquivo incluído com sucesso!', color: 'success', dialog: true })
            this.$socket.emit('generalDetailsEvent', {
              data: res.body,
              details: 'files',
              notBroadcast: true,
              responseEvent: 'addSocketDetails',
              room: `tasks${this.taskId}_manage`
            })
            // linha utilizada para informar a Tela de Arquivos que este elemento veio da tela de Tarefas
            res.body.source = 2
            // Emitindo evento para adicionar arquivo à tela de arquivos
            this.$socket.emit('generalEvent', {
              data: res.body,
              responseEvent: 'addSocketItem',
              room: `files${this.$auth.user().company_id}`
            })
          }, err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', { text: 'Não foi possível salvar o arquivo, reporte o erro.', color: 'error', dialog: true })
          })
        }).error(() => {
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', { text: 'Não foi possível gerar o arquivo, reporte o erro.', color: 'error', dialog: true })
        })
      }
    },
    computed: {
      values () {
        return this.$store.getters[`documentPreview/values`] || ''
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/PDocumentPreview.vue